import { style } from "@vanilla-extract/css";

import { rem } from "@huub-web/utils/css/rem";
import { theme } from "../../theme/css/theme.css";

export const waveContainerStyle = style({
  display: "flex",
  alignItems: "center",
  gap: rem(3),
});

export const waveBarStyle = style({
  width: rem(2),
  minHeight: rem(4),
  borderRadius: rem(1),
  backgroundColor: theme.colors.onBackground,
});
